<template>
	<SimpleTextInput
			v-bind="$attrs"
			v-on="$listeners"
			v-model="paginationHelper.searchTerm"
			append-icon="mdi-magnify"
			:placeholder="placeholder"
			clearable
			hide-details
			:readonly="selectedSearchFields.length === 0"
	>
		<template v-slot:prepend-inner v-if="!disallowSearchFieldsSelection">
			<v-menu
					v-model="menuOpen"
					style="top: -12px"
					offset-y
					:close-on-content-click="false"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
							v-bind="attrs"
							v-on="on"
							icon
							small
					>
						<v-icon>
							mdi-cog
						</v-icon>
					</v-btn>
				</template>
				<v-card>
					<v-card-title class="pb-0 mb-0 pl-3 pt-1">
						Sökbara fält
					</v-card-title>
					<v-card-text class="pa-2 pt-0 pb-0">
						<v-list dense class="pl-0 pr-0 pb-0 mb-0 pt-0">
							<template v-for="(item, index) in paginationHelper.searchFields">
								<v-list-item :key="index" class="pl-0 pr-0" v-if="!item.RequiredFtgInfoBool || FtgInfo[item.RequiredFtgInfoBool]">
									<v-list-item-action class="mr-1">
										<SimpleCheckbox v-model="item.selected" dense hide-details :label="item.text" :disabled="item.disabled" @change="onChangeSelectedSearchFields"/>
									</v-list-item-action>
								</v-list-item>
							</template>
						</v-list>
					</v-card-text>
					<v-card-actions>
						<v-btn depressed small color="primary" width="100%" @click="menuOpen = false">Stäng</v-btn>
					</v-card-actions>
				</v-card>
			</v-menu>
		</template>
	</SimpleTextInput>
</template>

<script>
import {mapState}      from 'vuex';
import SimpleTextInput from './SimpleTextInput.vue';
import Title           from './typography/Title.vue';
import SimpleCheckbox  from './SimpleCheckbox.vue';

export default {
	name: 'PaginationSearchField',

	props: ['paginationHelper', 'disallowSearchFieldsSelection'],

	data: () => ({
		menuOpen: false,
	}),

	methods: {
		onChangeSelectedSearchFields() {
			this.$emit('change:searchFields', this.paginationHelper.searchFields);
		},
	},

	computed: {
		...mapState(['FtgInfo']),

		selectedSearchFields() {
			const {searchFields = []} = this.paginationHelper;

			return searchFields.filter(({selected}) => selected);
		},

		placeholder() {
			const selectedSearchFields = this.selectedSearchFields;

			if(selectedSearchFields.length === 0) {
				this.paginationHelper.searchTerm = '';

				return 'Klicka på kugghjulet och välj minst 1 fält...';
			}

			return `Sök ${selectedSearchFields.map(({text}) => text.toLowerCase()).join(', ')}...`
		},
	},

	components: {SimpleCheckbox, Title, SimpleTextInput},
}
</script>

<style scoped>

</style>
